module.exports = __webpack_public_path__ + "static/media/report-template16.bdf5cfa0.svg";